import getDB from './util/getDB';

export const offlineTaskToProfileIdbKeyVal = getDB<{
    userId: string;
    display: string;
}>('OfflineTaskToProfile', 1, 'taskToProfile');
